import React, { useEffect, useState } from 'react';

const FloatingActions = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setShowTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const whatsappMessage = encodeURIComponent(
    'Hello Vigneshwara Power Controls, I would like to discuss an electrical project.'
  );

  return (
    <>
      {/* WhatsApp Button */}
      <a
  href="https://wa.me/917396748509?text=Hello%20Vigneshwara%20Power%20Controls,%20I%20would%20like%20to%20enquire."
  className="whatsapp-float"
  target="_blank"
  rel="noopener noreferrer"
>
  <div className="whatsapp-icon">
    <i className="fab fa-whatsapp"></i>
  </div>
  <span className="whatsapp-text">Chat With Us</span>
</a>



      {/* Scroll To Top */}
      {showTop && (
        <button
          className="scroll-top"
          onClick={() =>
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
        >
          <i className="fas fa-arrow-up"></i>
        </button>
      )}
    </>
  );
};

export default FloatingActions;
